import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthPage from './pages/AuthPage';
import Verificar2FA from './pages/Verificar2FA';
import ConfiguracionSMTP from './pages/ConfiguracionSMTP';
import TecnicoDashboard from './pages/TecnicoDashboard';
import ClienteDashboard from './pages/ClienteDashboard';
import AdminDashboard from './pages/AdminDashboard';
import CrearTecnico from './pages/CrearTecnico';
import ListaTecnicos from './pages/ListaTecnicos';
import CrearCliente from './pages/CrearCliente';
import ListaClientes from './pages/ListaClientes';
import EditarCliente from './pages/EditarCliente';
import GestionarClientes from './pages/GestionarClientes';
import GestionarLugares from './pages/GestionarLugares';
import GestionarCiudades from './pages/GestionarCiudades';
import CrearClienteEmpresa from './pages/CrearClienteEmpresa';
import EditarClienteEmpresa from './pages/EditarClienteEmpresa';
import UsuariosCliente from './pages/UsuariosCliente';
import GestionarTrabajos from './pages/GestionarTrabajos';
import AdminCrearTrabajo from './pages/AdminCrearTrabajo';
import TrabajoForm from './pages/TrabajoForm';
import TrabajoDetalle from './pages/TrabajoDetalle';
import CambiarContrasena from './pages/CambiarContrasena';
import Informes from './pages/Informes';
import ReporteUsuarios from './pages/ReporteUsuarios';
import ReporteTrabajos from './pages/ReporteTrabajos';
import MiPerfil from './pages/MiPerfil';
import RecuperarContrasena from './pages/RecuperarContrasena';
import RestablecerContrasena from './pages/RestablecerContrasena';
import './App.css';

const AppRoutes = () => {
  const { user } = useAuth();

  // Redirect to appropriate dashboard based on role
  const getDefaultRoute = () => {
    if (!user) return '/';
    if (user.rol === 'administrador') return '/admin';
    if (user.rol === 'tecnico') return '/tecnico';
    if (user.rol === 'cliente') return '/cliente';
    return '/';
  };

  return (
    <Routes>
      {/* Public Route - Auth Page */}
      <Route 
        path="/" 
        element={!user ? <AuthPage /> : <Navigate to={getDefaultRoute()} replace />} 
      />
      
      {/* Password Recovery Routes - Public */}
      <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
      <Route path="/restablecer-contrasena" element={<RestablecerContrasena />} />
      
      {/* 2FA Verification Route - Public but requires temp token */}
      <Route path="/verificar-2fa" element={<Verificar2FA />} />

      {/* Admin Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/crear-trabajo"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <AdminCrearTrabajo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/crear-tecnico"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <CrearTecnico />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/tecnicos"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <ListaTecnicos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/crear-cliente"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <CrearCliente />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clientes"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <ListaClientes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clientes/:clienteId/editar"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <EditarCliente />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clientes-empresa"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <GestionarClientes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clientes-empresa/crear"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <CrearClienteEmpresa />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clientes-empresa/:clienteId/editar"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <EditarClienteEmpresa />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clientes-empresa/:clienteId/usuarios"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <UsuariosCliente />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/clientes-empresa/:clienteId/lugares"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <GestionarLugares />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/ciudades"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <GestionarCiudades />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/configuracion-smtp"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <ConfiguracionSMTP />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/trabajos"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <GestionarTrabajos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/trabajo/:id"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <TrabajoDetalle />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/trabajo/:id/editar"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <TrabajoForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/informes"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <Informes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/reporte/usuarios"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <ReporteUsuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/reporte/trabajos"
        element={
          <ProtectedRoute allowedRoles={['administrador']}>
            <ReporteTrabajos />
          </ProtectedRoute>
        }
      />

      {/* Técnico Routes */}
      <Route
        path="/tecnico"
        element={
          <ProtectedRoute allowedRoles={['tecnico']}>
            <TecnicoDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tecnico/trabajo/nuevo"
        element={
          <ProtectedRoute allowedRoles={['tecnico']}>
            <TrabajoForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tecnico/trabajo/:id/editar"
        element={
          <ProtectedRoute allowedRoles={['tecnico']}>
            <TrabajoForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tecnico/trabajo/:id"
        element={
          <ProtectedRoute allowedRoles={['tecnico']}>
            <TrabajoDetalle />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tecnico/informes"
        element={
          <ProtectedRoute allowedRoles={['tecnico']}>
            <Informes />
          </ProtectedRoute>
        }
      />

      {/* Cliente Routes */}
      <Route
        path="/cliente"
        element={
          <ProtectedRoute allowedRoles={['cliente']}>
            <ClienteDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cliente/trabajo/:id"
        element={
          <ProtectedRoute allowedRoles={['cliente']}>
            <TrabajoDetalle />
          </ProtectedRoute>
        }
      />

      {/* Shared Routes */}
      <Route
        path="/mi-perfil"
        element={
          <ProtectedRoute>
            <MiPerfil />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cambiar-contrasena"
        element={
          <ProtectedRoute>
            <CambiarContrasena />
          </ProtectedRoute>
        }
      />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
